import React, { useEffect } from 'react'

const Dropdown = ({ ref, selectedValue, setSelectedValue, items, setSelectedDropdown, selectedDropdown, name }) => {

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref?.current && !ref?.current.contains(event.target)) {
                setSelectedDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleToggle = (key) => {
        let updated;
        if (selectedValue?.includes(key)) {
            updated = selectedValue?.filter((type) => type !== key);
        } else {
            updated = [...selectedValue, key];
        }
        setSelectedValue(updated);
    };

    return (
        <div ref={ref} className="select-university dropdown-wrapp">
            <button className="selectFields" onClick={(e) => setSelectedDropdown(!selectedDropdown)}>
                {name}{" "}
            </button>
            {
                selectedDropdown === true &&
                <div className="dropdown addDropdown">
                    <ul>
                        {items && items?.length > 0 &&
                            items?.map((item, index) => (
                                <li key={index} onClick={() => {
                                    handleToggle(item.key);
                                }}
                                >
                                    <input
                                        className="countrySelect"
                                        type="checkbox"
                                        checked={selectedValue?.includes(item?.key)}
                                        onChange={(e) => {
                                            e.stopPropagation();
                                            handleToggle(item.key);
                                        }}
                                    />
                                    <span className="country-flag">{item?.value}</span>
                                </li>
                            ))
                        }
                    </ul>
                </div>

            }
        </div>
    )
}

export default Dropdown
